import React from 'react';
import TransferApproval from './TransferApproval';
import { PermisionDenied } from '../../../views/pages/manage/common/commonComponents';
import { useGetPermissions } from '../../../layouts/customHook';

const TransferApprovalPage = () => {

    const userPermissions = useGetPermissions("studentTransferApproval");
    return (
        userPermissions
            ? <TransferApproval userPermissions={userPermissions} />
            : <PermisionDenied />
    );
}

export default TransferApprovalPage;